/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { toCurrency } from '@/lib/formatters/numeric'
import { toYesNo } from '@/lib/formatters/boolean'
import { dateTimeFormatters } from '@/lib/formatters/dateTime'

export function dateRenderer (params: any): string {
  return new Date(params.value).toLocaleDateString('en-US')
}

export function dateTimeRenderer(params: any): string {
  if (params.value) {
    return dateTimeFormatters.toDateTime(new Date(params.value))
  }
  else {
    return 'N/A'
  }
}

export function currencyRenderer (params: any): string {
  return toCurrency(params.value)
}

export function yesNoRenderer (params: any): string {
  return toYesNo(params.value)
}
